import React from 'react';
import { Box, Grid, Typography, IconButton, Link } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import pngwing from '../../Assets/Logo/pngwing.png'; // adjust the path as needed

const Footer = () => {
  return (
    <>
      {/* Main Footer */}
      <Box sx={{ backgroundColor: 'rgba(106, 106, 106, 0.09)', color: 'black', px: { xs: 2, sm: 4 }, py: 4 }}>
        <Grid container spacing={4} justifyContent="space-between">
          {/* Contact Info */}
          <Grid item xs={12} sm={6} md={3}>
            <Box display="flex" alignItems="center" mb={1}>
              <img src={pngwing} alt="Habuild" style={{ height: 50, marginRight: 10 }} />
            </Box>
            <Box display="flex" alignItems="flex-start">
              <LocationOnIcon sx={{ mr: 1 }} />
              <Box>
                
                <Typography variant="body2">
                  SR NO. 15/11/1, Waraje Naka, Canal Road<br />
                  Hingane Budruk, Pune,<br />
                  Maharashtra 411058
                </Typography>
              </Box>
            </Box>
            <Box display="flex" alignItems="center" mt={2}>
              <PhoneIcon sx={{ mr: 1 }} />
              <Typography variant="body2" fontWeight="bold">
                <span style={{ fontWeight: 400 }}>9356461900</span>
              </Typography>
            </Box>
            <Box mt={2}>
              <IconButton color="inherit"><FacebookIcon /></IconButton>
              <IconButton color="inherit"><InstagramIcon /></IconButton>
              <IconButton color="inherit"><YouTubeIcon /></IconButton>
              <IconButton color="inherit"><LinkedInIcon /></IconButton>
            </Box>
          </Grid>

          {/* About Us */}
          <Grid item xs={6} sm={6} md={2}>
            <Typography variant="h6" gutterBottom>About Us</Typography>
            <Typography variant="body2">Home</Typography>
            <Typography variant="body2">Pricing</Typography>
            <Typography variant="body2">Events</Typography>
          </Grid>

          {/* Blog */}
          <Grid item xs={6} sm={6} md={2}>
            <Typography variant="h6" gutterBottom>Blog</Typography>
            <Typography variant="body2">Nutrition</Typography>
            <Typography variant="body2">Physical</Typography>
            <Typography variant="body2">Mental Wellness</Typography>
            <Typography variant="body2">Lifestyle</Typography>
          </Grid>

          {/* Cities */}
          <Grid item xs={6} sm={6} md={2}>
            <Typography variant="h6" gutterBottom>Popular cities</Typography>
            <Typography variant="body2">Kolhapur</Typography>
            <Typography variant="body2">Mumbai</Typography>
            <Typography variant="body2">Pune</Typography>
            <Typography variant="body2">Hydrabad</Typography>
            <Typography variant="body2">Ahmedabad</Typography>
          </Grid>

        </Grid>
      </Box>

      {/* Bottom Bar */}
      <Box
        sx={{
          backgroundColor: 'rgba(15, 6, 6, 0.43)',
          color: 'white',
          py: 2,
          px: { xs: 2, sm: 4 },
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          flexDirection={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
        >
          <Typography variant="body2" sx={{ textAlign: { xs: 'left', md: 'left' } }}>
            © 2025 Yoga Private Limited. All rights reserved.
          </Typography>
          <Box mt={{ xs: 1, md: 0 }} display="flex" flexWrap="wrap" gap={2}>
            <Link href="#" color="inherit" underline="hover" sx={{ fontSize: '0.875rem' }}>Privacy Policy</Link>
            <Link href="#" color="inherit" underline="hover" sx={{ fontSize: '0.875rem' }}>Refund Policy</Link>
            <Link href="#" color="inherit" underline="hover" sx={{ fontSize: '0.875rem' }}>Terms of Use</Link>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
